<section class="w-full">
  <h2 class="text-2xl font-bold mb-6 text-gray-800">Meine Zähleranträge</h2>

  @if (eiegeneZaehlerAntraege.isLoading()) {
    <div class="flex items-center justify-center py-12">
      <div class="text-center">
        <div class="w-12 h-12 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin mx-auto mb-4"></div>
        <p class="text-gray-600">Zähleranträge werden geladen...</p>
      </div>
    </div>
  } @else if (eiegeneZaehlerAntraege.error()) {
    <div class="bg-red-50 border border-red-200 rounded-lg p-4 text-red-700">
      <p class="font-medium">Fehler beim Laden der Zähleranträge</p>
      <p class="text-sm mt-1">{{ eiegeneZaehlerAntraege.error()?.message }}</p>
    </div>
  } @else if ((eiegeneZaehlerAntraege.value() || []).length === 0) {
    <div class="bg-blue-50 border border-blue-200 rounded-lg p-6 text-center">
      <p class="text-gray-700 font-medium">Keine Zähleranträge vorhanden</p>
      <p class="text-sm text-gray-600 mt-2">Sie haben noch keinen Zähler beantragt.</p>
    </div>
  } @else {
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      @for (zaehlerAntrag of eiegeneZaehlerAntraege.value(); track zaehlerAntrag?.id) {
        <div class="rounded-lg bg-white shadow hover:shadow-md transition-shadow border border-gray-100">
          <!-- Card Header mit Status -->
          <div [class]="'rounded-t-lg px-4 py-3 border-b border-gray-100 ' + getStatusClass(zaehlerAntrag?.genehmigt, zaehlerAntrag?.abgelehnt)">
            <div class="flex items-center justify-between gap-2">
              <div class="flex items-center gap-2 flex-1 min-w-0">
                <fa-icon
                  [icon]="getStatusIcon(zaehlerAntrag?.genehmigt, zaehlerAntrag?.abgelehnt)"
                  [class]="getStatusIconClass(zaehlerAntrag?.genehmigt, zaehlerAntrag?.abgelehnt)"
                  aria-hidden="true">
                </fa-icon>
                <span class="text-sm font-medium text-gray-800 truncate">{{ getStatusLabel(zaehlerAntrag?.genehmigt, zaehlerAntrag?.abgelehnt) }}</span>
              </div>
              <span [class]="'uppercase inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ' + getStatusBadgeClass(zaehlerAntrag?.genehmigt, zaehlerAntrag?.abgelehnt)">
                {{ zaehlerAntrag?.zaehlernummer }}
              </span>
            </div>
          </div>

          <!-- Card Content -->
          <div class="px-4 py-4 space-y-3">
            <!-- Ort -->
            <div>
              <p class="text-xs font-semibold text-gray-500 uppercase">Einbauort</p>
              <p class="text-sm text-gray-800 mt-1 font-mono wrap-break-word">{{ zaehlerAntrag?.ort || '—' }}</p>
            </div>

            <!-- Einbaudatum -->
            <div>
              <p class="text-xs font-semibold text-gray-500 uppercase">Einbaudatum</p>
              <p class="text-sm text-gray-800 font-mono mt-1">
                @if (zaehlerAntrag?.einbaudatum) {
                  {{ zaehlerAntrag?.einbaudatum | dateTimeFromIso | dateTimeToFormat:'dd. MMMM yyyy' }}
                } @else {
                  —
                }
              </p>
            </div>
          </div>
        </div>
      }
    </div>
  }
</section>
